import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Observable,
  catchError,
  map,
  publishReplay,
  refCount,
  throwError,
} from 'rxjs';
import { environment } from 'src/environments/environment';
import { ScenarioVersion } from '../models/scenario-version.model';

@Injectable({
  providedIn: 'root'
})
export class ScenarioVersionService {
  slug = '/scenario_versions';

  allScenarioVersion?: Observable<any[]>[] | null | any = {};

  constructor(private http: HttpClient) {}
  fetchAll(scenarioId: any): Observable<any[]> {
    let searchParams = new HttpParams();
    searchParams = searchParams.append('scenario_id', scenarioId.toString());
    searchParams = searchParams.append('slim', '1');

    if (!this.allScenarioVersion[scenarioId]) {
      this.allScenarioVersion[scenarioId] = this.http
        .get<any>(environment.apiUrl + this.slug, {
          responseType: 'json',
          params: searchParams,
        })
        .pipe(
          map((responseData) => {
            return responseData._embedded.scenario_versions;
          }),
          catchError((errorRes) => {
            return throwError(errorRes);
          }),
          publishReplay(1),
          refCount()
        );
    }

    return this.allScenarioVersion[scenarioId];
  }

  clearCache() {
    this.allScenarioVersion = {};
  }

  fetch(id: number) {
    return this.http
      .get<any>(environment.apiUrl + this.slug + '/' + id, {
        responseType: 'json',
      })
      .pipe(
        map((responseData) => {
          const item = new ScenarioVersion(
            +responseData.scenario_version_id,
            responseData.scenario_id,
            +responseData.user_id,
            responseData.name,
            responseData.scenario_data,
            responseData.main,
            responseData.autosave,
            responseData.created,
            responseData.modified
          );
          return item;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        })
      );
  }

  create(scenario_id: number, name: string, scenario_data: string, main:number, autosave:number) {
    this.clearCache();
    const payload = {
      scenario_id,
      name,
      scenario_data,
      main,
      autosave
    };
    return this.http.post<ScenarioVersion>(environment.apiUrl + this.slug, payload, {
      observe: 'response',
    });
  }

  update(id: number, scenario_id: number, name: string, scenario_data: string, main:number, autosave:number) {
    this.clearCache();
    const payload = {
      scenario_id,
      name,
      scenario_data,
      main,
      autosave
    };
    return this.http.patch<ScenarioVersion>(
      environment.apiUrl + this.slug + '/' + id,
      payload,
      {
        observe: 'response',
      }
    );
  }

  delete(id: number) {
    this.clearCache();
    return this.http.delete<{ name: string }>(
      environment.apiUrl + this.slug + '/' + id
    );
  }
}
